import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`solicitudes-inscripciones-reportes/${id}`), opciones);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-inscripciones-reportes'), { params: opciones.params });
  },
};
